import { HttpClient, HttpParams } from '@angular/common/http';
import { ChangeDetectorRef, Component, ElementRef, Inject, OnDestroy, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { Gruppe } from '../../../../../projects/kiene-core/src/lib/components/gruppen/classes/gruppe';
import { GruppenService } from '../../../../../projects/kiene-core/src/lib/components/gruppen/gruppen.service';
import {
    PdfViewerDesktopService,
    PdfViewerDialogInput,
} from '../../../../../projects/kiene-core/src/lib/components/pdf-viewer/kiene-pdf-viewer/kiene-pdf-viewer-desktop/pdf-viewer-desktop.service';
import { API_BASE_URL_SERVICE } from '../../../../../projects/kiene-core/src/lib/kiene-core.config';
import { KieneSession } from '../../../../../projects/kiene-core/src/lib/services/local-storage/kiene-session';
import { LocalStorageService } from '../../../../../projects/kiene-core/src/lib/services/local-storage/local-storage.service';
import { KieneTableService } from '../../../components/kiene-table/kiene-table.service';
import { ConfirmDeleteDialogComponent } from '../../../dialogs/confirm-delete-dialog/confirm-delete-dialog.component';
import { KieneConstants } from '../../../kiene-constants';
import { Material } from '../../../warehouse/material/material';
import { Supplier } from '../../../warehouse/supplier/supplier';
import { Untersuchungsmaterial } from '../../untersuchungsmaterialien/untersuchungsmaterial';
import {
    Untersuchungsauftrag,
    UntersuchungsauftragDokument,
    UntersuchungsauftragPosition,
} from '../untersuchungsauftrag';
import { MessageService } from '../../../../../projects/kiene-core/src/lib/services/message-service/message.service';
import { UnterschriftService } from '../../../../../projects/kiene-core/src/lib/components/stammdaten/unterschrift/unterschrift.service';
import { Signature } from '../../../../../projects/kiene-core/src/lib/components/unterschriften/signature';
import { UnterschriftenService } from '../../../../../projects/kiene-core/src/lib/components/unterschriften/unterschriften.service';

interface FillOverlay {
    page: number;
    x: number;
    y: number;
    size: number;
    placeholder: string;
    label: string;
    kind: 'text' | 'checkbox' | 'context';
    width?: number;
    lines?: number;
}

interface FillPageInfo {
    page: number;
    width: number;
    height: number;
}

@Component({
    selector: 'kiene-untersuchungsauftrag-details',
    templateUrl: './untersuchungsauftrag-details.component.html',
    styleUrls: ['./untersuchungsauftrag-details.component.scss'],
})
export class UntersuchungsauftragDetailsComponent implements OnInit, OnDestroy {
    @ViewChild('pdfHost') pdfHost: ElementRef<HTMLElement>;
    untersuchungsauftragId = 'neu';
    gruppe: Gruppe;
    labor: Supplier;
    untersuchungsmaterial: Untersuchungsmaterial;
    kieneSession: KieneSession;

    artikelCtrl = new UntypedFormControl();
    anzahlCtrl = new UntypedFormControl();
    notizCtrl = new UntypedFormControl();
    kennzeichnungCtrl = new UntypedFormControl();
    probenentnahmeCtrl = new UntypedFormControl();
    tagebuchCtrl = new UntypedFormControl();

    untersuchungsauftrag: Untersuchungsauftrag = new Untersuchungsauftrag();

    selectedArtikel: Material;

    positionen: UntersuchungsauftragPosition[] = [];

    untersuchungsauftragDokumente: UntersuchungsauftragDokument[] = [];

    /** Freitext-Felder aus dem Formular-Mapping */
    formularCustomFields: { key: string; label: string; type?: 'text' | 'checkbox' }[] = [];
    formularWerte: { [key: string]: string } = {};
    fillOverlays: FillOverlay[] = [];
    fillPages: FillPageInfo[] = [];
    fillPage = 1;
    fillPageCount = 1;
    fillPdfSrc: Uint8Array | null = null;
    fillPdfLoading = false;
    fillPdfError = '';
    fillLayoutTick = 0;
    private fillScale = 1;
    private readonly onFillResize = () => this.placeFillMarks();

    params = new HttpParams();

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        @Inject(API_BASE_URL_SERVICE) private apiBaseUrl: string,
        private api: KieneTableService,
        private gruppenService: GruppenService,
        private notification: MessageService,
        private localStorageService: LocalStorageService,
        private cd: ChangeDetectorRef,
        private pdfViewer: PdfViewerDesktopService,
        public dialog: MatDialog,
        private http: HttpClient,
        private unterschriftService: UnterschriftService,
        private unterschriftenService: UnterschriftenService,
    ) {
        this.untersuchungsauftragId = this.route.snapshot.paramMap.get('id');
        this.kieneSession = localStorageService.getCurrentUser();
    }

    ngOnDestroy() {
        window.removeEventListener('resize', this.onFillResize);
    }

    ngOnInit() {
        window.addEventListener('resize', this.onFillResize);
        if (this.untersuchungsauftragId !== 'neu') {
            this.loadUntersuchungsauftrag();
        } else if (this.untersuchungsauftragId === 'neu') {
            this.untersuchungsauftrag.status_id = KieneConstants.STATUS.UNTERSUCHUNGSAUFTRAG.ERSTELLT;
        }
    }

    checkEnterKey(event) {
        if (event.keyCode === 13) {
            this.addCurrentPosition();
        }
    }

    loadUntersuchungsauftrag() {
        this.api
            .getOne(
                this.apiBaseUrl + 'untersuchungsauftrag/read_one.php',
                'untersuchungsauftrag_id',
                this.untersuchungsauftragId,
            )
            .subscribe(response => {
                this.untersuchungsauftrag = response;
                this.params = new HttpParams().set(
                    'lieferant_id_labor',
                    this.untersuchungsauftrag.lieferant_id.toString(),
                );
                this.initFormularFreitexte();
                this.loadPositionen();
                this.initFields();
                this.loadDokumente();
            });
    }

    loadPositionen() {
        let params = new HttpParams();
        params = params.append('untersuchungsauftrag_id', this.untersuchungsauftrag.untersuchungsauftrag_id.toString());
        this.api.get(this.apiBaseUrl + 'untersuchungsauftrag_artikel/read.php', params).subscribe({
            next: response => {
                this.positionen = response.records;
            },
            error: error => {
                this.notification.errorMessage('Positionen konnten nicht geladen werden!', error);
            },
        });
    }

    loadDokumente() {
        const params = new HttpParams().append(
            'untersuchungsauftrag_id',
            this.untersuchungsauftrag.untersuchungsauftrag_id.toString(),
        );
        this.api.get(this.apiBaseUrl + 'untersuchungsauftrag_dokument/read.php', params).subscribe(response => {
            this.untersuchungsauftragDokumente = response.records;
        });
    }

    removeUntersuchungsauftragDokument(ud: UntersuchungsauftragDokument) {
        const dialogRef = this.dialog.open(ConfirmDeleteDialogComponent, {
            width: '25%',
            data: {
                title: ud.dateiname + ' löschen?',
                text: 'Wollen Sie die Datei ' + ud.dateiname + ' wirklich löschen?',
            },
        });

        dialogRef.afterClosed().subscribe(result => {
            if (result) {
                this.api
                    .deleteEntity(this.apiBaseUrl + 'untersuchungsauftrag_dokument/delete.php', ud)
                    .subscribe(() => {
                        this.loadDokumente();
                    });
            }
        });
    }

    untersuchungsauftragDokumentSelected(untersuchungsauftragDokument: UntersuchungsauftragDokument) {
        this.pdfViewer.openPdfViewer(
            new PdfViewerDialogInput(
                'untersuchungsauftrag_dokument/read_pdf.php',
                new HttpParams().set('ud_id', untersuchungsauftragDokument?.ud_id?.toString()),
                untersuchungsauftragDokument.dateiname,
            ),
        );
    }

    loadGruppe(gruppe_id: number) {
        this.gruppenService.getGruppePraxissoftware(gruppe_id).subscribe(cg => {
            this.gruppe = <Gruppe>cg;
        });
    }

    loadLabor(lieferant_id: number) {
        if (!lieferant_id) {
            return;
        }
        const name = (this.untersuchungsauftrag?.lieferant || '').trim();
        if (name) {
            const labor = new Supplier();
            labor.lieferant_id = lieferant_id;
            labor.bezeichnung = name;
            this.labor = labor;
        }
        if (this.vomBefund() || !this.localStorageService.currentUserHasPermission(1071)) {
            return;
        }
        this.api
            .getOne(this.apiBaseUrl + 'lieferant/read_one.php', 'lieferant_id', lieferant_id.toString())
            .subscribe(labor => (this.labor = labor));
    }

    setLabor(labor: Supplier) {
        this.labor = labor;
        if (this.labor) {
            this.params = new HttpParams().set('lieferant_id_labor', this.labor.lieferant_id.toString());
        }
    }

    loadUntersuchungsmaterial(untersuchungsmaterial_id: number) {
        if (untersuchungsmaterial_id) {
            this.api
                .getOne(
                    this.apiBaseUrl + 'untersuchungsmaterial/read_one.php',
                    'untersuchungsmaterial_id',
                    untersuchungsmaterial_id.toString(),
                )
                .subscribe(untersuchungsmaterial => (this.untersuchungsmaterial = untersuchungsmaterial));
        }
    }

    openFormular(tpl: TemplateRef<unknown>) {
        this.dialog.open(tpl, {
            width: '96vw',
            maxWidth: '1100px',
            maxHeight: '92vh',
            panelClass: 'ua-formular-dialog',
            autoFocus: false,
        });
    }

    showFertigePdf() {
        if (this.untersuchungsauftrag?.status_id !== 92 || !this.untersuchungsauftrag?.pdf_id) {
            return;
        }
        this.pdfViewer.openPdfViewer(
            new PdfViewerDialogInput(
                'untersuchungsauftrag/read_or_mail_pdf.php',
                new HttpParams().set(
                    'untersuchungsauftrag_id',
                    this.untersuchungsauftrag.untersuchungsauftrag_id.toString(),
                ),
                'Externer Untersuchungsauftrag ' + this.untersuchungsauftrag.untersuchungsauftrag_id,
                { email: { sende_mail: true, kunde_id: this.untersuchungsauftrag.kunde_id } },
            ),
        );
    }

    showFormular() {
        if (!this.untersuchungsauftrag?.lieferant_dokument_id) {
            return;
        }
        this.pdfViewer.openPdfViewer(
            new PdfViewerDialogInput(
                'lieferant_dokument/read_pdf.php',
                new HttpParams().set('ld_id', this.untersuchungsauftrag.lieferant_dokument_id.toString()),
                this.untersuchungsauftrag.formular_dateiname || 'Untersuchungsformular',
            ),
        );
    }

    goToBestellung() {
        if (!this.untersuchungsauftrag?.bestellung_extern_id) {
            return;
        }
        this.router.navigate(['/wawi', 'bestellung-extern', 'lieferanten', this.untersuchungsauftrag.bestellung_extern_id]).then();
    }

    goToBefund() {
        if (!this.untersuchungsauftrag?.befund_id) {
            return;
        }
        this.router.navigate(['/labor', 'befundmitteilungen', this.untersuchungsauftrag.befund_id]).then();
    }

    initFormularFreitexte() {
        let mapping = this.untersuchungsauftrag?.formular_feld_mapping;
        if (typeof mapping === 'string' && mapping) {
            try {
                mapping = JSON.parse(mapping);
            } catch {
                mapping = null;
            }
        }
        const raw = mapping?.custom_fields;
        this.formularCustomFields = Array.isArray(raw)
            ? raw
                  .filter((c: any) => c && c.key && c.label)
                  .map((c: any) => ({
                      key: String(c.key),
                      label: String(c.label),
                      type: c.type === 'checkbox' ? 'checkbox' : 'text',
                  }))
            : [];

        let werte = this.untersuchungsauftrag?.formular_werte as any;
        if (typeof werte === 'string' && werte) {
            try {
                werte = JSON.parse(werte);
            } catch {
                werte = {};
            }
        }
        if (!werte || typeof werte !== 'object') {
            werte = {};
        }
        const next: { [key: string]: string } = {};
        for (const f of this.formularCustomFields) {
            const prev = werte[f.key] != null ? String(werte[f.key]) : '';
            if (f.type === 'checkbox') {
                next[f.key] = prev === '1' || prev === '0' ? prev : '';
            } else {
                next[f.key] = prev;
            }
        }
        this.formularWerte = next;
        this.initFillOverlays(mapping);
        this.loadFillPdf();
    }

    formularGesperrt(): boolean {
        return (this.untersuchungsauftrag?.status_id || 0) >= 92;
    }

    formularFelderOhneOverlay() {
        const placed = new Set(
            this.fillOverlays.filter(o => o.kind !== 'context').map(o => o.placeholder),
        );
        return this.formularCustomFields.filter(f => !placed.has(f.key));
    }

    overlaysOnFillPage(): FillOverlay[] {
        return this.fillOverlays.filter(o => o.page === this.fillPage);
    }

    toggleFormularCheckbox(key: string) {
        if (this.formularGesperrt()) {
            return;
        }
        this.formularWerte[key] = this.formularWerte[key] === '1' ? '0' : '1';
    }

    prevFillPage() {
        if (this.fillPage > 1) {
            this.fillPage--;
        }
    }

    nextFillPage() {
        if (this.fillPage < this.fillPageCount) {
            this.fillPage++;
        }
    }

    onFillPdfLoad(pdf: {
        numPages?: number;
        getPage?: (n: number) => Promise<{ getViewport: (o: { scale: number }) => { width: number; height: number } }>;
    }) {
        if (pdf?.numPages && pdf.numPages > 0) {
            this.fillPageCount = Math.max(this.fillPageCount, pdf.numPages);
        }
        if (pdf?.getPage && pdf.numPages) {
            const n = pdf.numPages;
            Promise.all(
                Array.from({ length: n }, (_, i) =>
                    pdf.getPage!(i + 1).then(page => {
                        const vp = page.getViewport({ scale: 1 });
                        return { page: i + 1, width: vp.width, height: vp.height };
                    }),
                ),
            ).then(pages => {
                this.fillPages = pages;
                this.placeFillMarks();
            });
        }
        setTimeout(() => this.placeFillMarks(), 0);
    }

    placeFillMarks() {
        const host =
            (document.querySelector('.ua-formular-dialog .ua-pdf-host') as HTMLElement) ||
            this.pdfHost?.nativeElement;
        if (!host) {
            return;
        }
        const marks = host.querySelector('.ua-pdf-marks') as HTMLElement;
        const scroller = host.querySelector('.ng2-pdf-viewer-container') as HTMLElement;
        if (!marks || !scroller) {
            return;
        }
        const sync = () => {
            const canvas = host.querySelector('.page canvas') as HTMLElement;
            if (!canvas) {
                return;
            }
            const hostRect = host.getBoundingClientRect();
            const canvasRect = canvas.getBoundingClientRect();
            if (canvasRect.width <= 0 || canvasRect.height <= 0) {
                return;
            }
            marks.style.transform =
                'translate(' + (canvasRect.left - hostRect.left) + 'px,' + (canvasRect.top - hostRect.top) + 'px)';
            marks.style.width = canvasRect.width + 'px';
            marks.style.height = canvasRect.height + 'px';
        };
        sync();
        const scrollerAny = scroller as HTMLElement & { __uaSync?: boolean; __uaRaf?: number };
        if (!scrollerAny.__uaSync) {
            scrollerAny.__uaSync = true;
            scroller.addEventListener(
                'scroll',
                () => {
                    if (scrollerAny.__uaRaf) {
                        return;
                    }
                    scrollerAny.__uaRaf = requestAnimationFrame(() => {
                        scrollerAny.__uaRaf = 0;
                        sync();
                    });
                },
                { passive: true },
            );
        }
        const canvas = host.querySelector('.page canvas') as HTMLElement;
        if (!canvas || canvas.clientWidth <= 0) {
            return;
        }
        const page = this.fillPages.find(p => p.page === this.fillPage);
        const next = canvas.clientWidth / (page?.width || 595);
        if (Math.abs(this.fillScale - next) > 0.02) {
            this.fillScale = next;
            this.fillLayoutTick++;
            this.cd.detectChanges();
        }
    }

    isFillTextBlock(e: FillOverlay): boolean {
        return e.kind === 'text' && (e.lines || 0) > 1 && (e.width || 0) > 20;
    }

    /** Eine Zeile, Breite wie der aufgezogene Block. */
    fillLineStyle(e: FillOverlay): { [k: string]: string } {
        const base = this.fillMarkerStyle(e);
        if ((e.width || 0) <= 12) {
            return { ...base, width: '140px' };
        }
        const page = this.fillPages.find(p => p.page === e.page);
        const w = page?.width || 595;
        return {
            ...base,
            width: ((e.width || 0) / w) * 100 + '%',
            maxWidth: 'none',
            boxSizing: 'border-box',
        };
    }

    fillBlockStyle(e: FillOverlay): { [k: string]: string } {
        const base = this.fillMarkerStyle(e);
        const page = this.fillPages.find(p => p.page === e.page);
        const w = page?.width || 595;
        const h = page?.height || 842;
        const size = e.size || 9;
        const lines = e.lines || 1;
        return {
            ...base,
            width: ((e.width || 0) / w) * 100 + '%',
            height: ((lines * size * 1.25) / h) * 100 + '%',
        };
    }

    fillMarkerStyle(e: FillOverlay): { [k: string]: string } {
        void this.fillLayoutTick;
        const page = this.fillPages.find(p => p.page === e.page);
        const w = page?.width || 595;
        const h = page?.height || 842;
        return {
            left: (e.x / w) * 100 + '%',
            top: ((h - e.y) / h) * 100 + '%',
            fontSize: Math.max(11, Math.round((e.size || 9) * this.fillScale)) + 'px',
        };
    }

    private initFillOverlays(mapping: any) {
        const raw = Array.isArray(mapping?.entries) ? mapping.entries : [];
        const byKey = new Map(this.formularCustomFields.map(f => [f.key, f]));
        this.fillOverlays = raw
            .filter((e: any) => e && e.kind === 'overlay' && e.placeholder)
            .map((e: any) => {
                const key = String(e.placeholder);
                const custom = byKey.get(key);
                const kind: FillOverlay['kind'] = custom
                    ? custom.type === 'checkbox'
                        ? 'checkbox'
                        : 'text'
                    : 'context';
                return {
                    page: Number(e.page) || 1,
                    x: Number(e.x) || 0,
                    y: Number(e.y) || 0,
                    size: Number(e.size) || (kind === 'checkbox' ? 11 : 9),
                    width: Number(e.width) > 20 ? Number(e.width) : undefined,
                    lines: Number(e.lines) > 1 ? Number(e.lines) : undefined,
                    placeholder: key,
                    label: custom?.label || this.contextLabel(key),
                    kind,
                };
            });
    }

    private contextLabel(key: string): string {
        const tail = key.split('.').pop() || key;
        return tail.replace(/_/g, ' ');
    }

    private loadFillPdf() {
        this.fillPdfSrc = null;
        this.fillPdfError = '';
        const ldId = this.untersuchungsauftrag?.lieferant_dokument_id;
        if (!ldId || !this.fillOverlays.length) {
            this.fillPdfLoading = false;
            return;
        }
        this.fillPdfLoading = true;
        this.http
            .get(this.apiBaseUrl + 'lieferant_dokument/read_pdf.php', {
                params: new HttpParams().set('ld_id', String(ldId)),
                responseType: 'blob',
            })
            .subscribe({
                next: blob => {
                    blob.arrayBuffer().then(buf => {
                        const bytes = new Uint8Array(buf);
                        const head = new TextDecoder().decode(bytes.slice(0, 5));
                        if (head !== '%PDF-') {
                            this.fillPdfLoading = false;
                            this.fillPdfError = 'Formular-PDF konnte nicht geladen werden.';
                            return;
                        }
                        this.fillPdfSrc = bytes;
                        this.fillPdfLoading = false;
                    });
                },
                error: () => {
                    this.fillPdfLoading = false;
                    this.fillPdfError = 'Formular-PDF konnte nicht geladen werden.';
                },
            });
    }

    initFields() {
        this.kennzeichnungCtrl.setValue(this.untersuchungsauftrag.kennzeichnung);
        this.probenentnahmeCtrl.setValue(this.untersuchungsauftrag.datum);
        this.tagebuchCtrl.setValue(this.untersuchungsauftrag.tagebuch_nr);
        this.loadGruppe(this.untersuchungsauftrag.gruppe_id);
        this.loadLabor(this.untersuchungsauftrag.lieferant_id);
        this.loadUntersuchungsmaterial(this.untersuchungsauftrag.untersuchungsmaterial_id);

        if (this.vomBefund() || this.untersuchungsauftrag.status_id >= 92) {
            this.kennzeichnungCtrl.disable();
            this.probenentnahmeCtrl.disable();
            this.tagebuchCtrl.disable();
        } else {
            this.kennzeichnungCtrl.enable();
            this.probenentnahmeCtrl.enable();
            this.tagebuchCtrl.enable();
        }
    }

    /** Auftrag aus einem Befund: Kunde, Gruppe, Labor, Artikel und Kopfdaten stehen fest. */
    vomBefund(): boolean {
        return Number(this.untersuchungsauftrag?.befund_id) > 0;
    }

    reopen() {
        if (!this.kannWiederOeffnen()) {
            this.notification.infoMessage(this.wiederOeffnenHinweis());
            return;
        }
        this.save(KieneConstants.STATUS.UNTERSUCHUNGSAUFTRAG.ERSTELLT);
    }

    kannWiederOeffnen(): boolean {
        return this.untersuchungsauftrag?.status_id === 92 && !this.perMailVersendet() && !this.befundAbgeschlossen();
    }

    wiederOeffnenHinweis(): string {
        if (this.perMailVersendet()) {
            return 'Bereits per Mail versendet. Wieder öffnen ist nicht mehr möglich.';
        }
        if (this.befundAbgeschlossen()) {
            return 'Der zugehörige Befund ist abgeschlossen. Wieder öffnen ist nicht mehr möglich.';
        }
        return 'Setzt den Auftrag zurück auf erstellt, damit Felder und Formular wieder bearbeitet werden können.';
    }

    private perMailVersendet(): boolean {
        return Number(this.untersuchungsauftrag?.mail) > 0;
    }

    private befundAbgeschlossen(): boolean {
        return Number(this.untersuchungsauftrag?.befund_status_id) === 12;
    }

    setArtikel(artikel: Material) {
        this.selectedArtikel = artikel;
    }

    addCurrentPosition() {
        const pbp = this.createCurrentPosition();
        this.positionen.push(pbp);
        this.clearInputs();
        this.save(KieneConstants.STATUS.UNTERSUCHUNGSAUFTRAG.ERSTELLT);
    }

    clearInputs() {
        this.artikelCtrl.setValue(null);
        this.anzahlCtrl.setValue(null);
        this.notizCtrl.setValue(null);
        this.cd.detectChanges();
    }

    close() {
        if (!this.formularHatUnterschrift()) {
            this.save(KieneConstants.STATUS.UNTERSUCHUNGSAUFTRAG.ABGESCHLOSSEN);
            return;
        }
        this.unterschriftService.getSignatur().subscribe({
            next: (response: { unterschrift?: string; unterschrift_png?: string }) => {
                const datei = (response?.unterschrift || '').trim();
                const png = (response?.unterschrift_png || '').trim();
                if (datei || png) {
                    this.save(KieneConstants.STATUS.UNTERSUCHUNGSAUFTRAG.ABGESCHLOSSEN);
                    return;
                }
                this.unterschriftAnlegenDannAbschliessen();
            },
            error: error => {
                this.notification.errorMessage('Die hinterlegte Unterschrift konnte nicht geprüft werden.', error);
            },
        });
    }

    private formularHatUnterschrift(): boolean {
        let mapping = this.untersuchungsauftrag?.formular_feld_mapping;
        if (typeof mapping === 'string' && mapping) {
            try {
                mapping = JSON.parse(mapping);
            } catch {
                return false;
            }
        }
        const entries = Array.isArray(mapping?.entries) ? mapping.entries : [];
        return entries.some(
            (e: any) => e && e.kind === 'overlay' && String(e.placeholder || '') === 'ua.unterschrift',
        );
    }

    private unterschriftAnlegenDannAbschliessen() {
        const signature = new Signature();
        signature.benutzer = 1;
        this.unterschriftenService.unterschreiben(signature).subscribe({
            next: () => {
                this.unterschriftService.getSignatur().subscribe({
                    next: (response: { unterschrift?: string; unterschrift_png?: string }) => {
                        const datei = (response?.unterschrift || '').trim();
                        const png = (response?.unterschrift_png || '').trim();
                        if (datei || png) {
                            this.save(KieneConstants.STATUS.UNTERSUCHUNGSAUFTRAG.ABGESCHLOSSEN);
                            return;
                        }
                        this.notification.infoMessage(
                            'Abschließen abgebrochen. Ohne hinterlegte Unterschrift wird der Auftrag nicht abgeschlossen.',
                        );
                    },
                    error: error => {
                        this.notification.errorMessage('Die hinterlegte Unterschrift konnte nicht geprüft werden.', error);
                    },
                });
            },
        });
    }

    save(status_id?: number) {
        this.untersuchungsauftrag.positionen = this.positionen;
        this.untersuchungsauftrag.gruppe_id = this.gruppe.gruppe_id;
        this.untersuchungsauftrag.datum = this.probenentnahmeCtrl.value;
        this.untersuchungsauftrag.tagebuch_nr = this.tagebuchCtrl.value;
        if (this.labor) {
            this.untersuchungsauftrag.lieferant_id = this.labor.lieferant_id;
        }
        if (this.untersuchungsmaterial) {
            this.untersuchungsauftrag.untersuchungsmaterial_id = this.untersuchungsmaterial.untersuchungsmaterial_id;
        }
        this.untersuchungsauftrag.kennzeichnung = this.kennzeichnungCtrl.value;
        if (this.formularCustomFields.length) {
            this.untersuchungsauftrag.formular_werte = { ...this.formularWerte };
        }

        if (status_id) {
            this.untersuchungsauftrag.status_id = status_id;
        }
        this.api
            .updateEntity(this.apiBaseUrl + 'untersuchungsauftrag/update.php', this.untersuchungsauftrag)
            .subscribe({
                next: response => {
                    this.notification.infoMessage('Der Untersuchungsauftrag wurde erfolgreich gespeichert!');
                    this.untersuchungsauftrag = response;
                    this.initFields();
                    this.untersuchungsauftragId = this.untersuchungsauftrag.untersuchungsauftrag_id.toString();
                    this.loadPositionen();
                    if (
                        this.untersuchungsauftrag.status_id === KieneConstants.STATUS.UNTERSUCHUNGSAUFTRAG.ABGESCHLOSSEN
                    ) {
                        this.pdfViewer.openPdfViewer(
                            new PdfViewerDialogInput(
                                'untersuchungsauftrag/read_or_mail_pdf.php',
                                new HttpParams().set(
                                    'untersuchungsauftrag_id',
                                    this.untersuchungsauftrag?.untersuchungsauftrag_id?.toString(),
                                ),
                                'Externer Untersuchungsauftrag ' + this.untersuchungsauftrag.untersuchungsauftrag_id,
                                {
                                    targetRoute: ['/labor', 'untersuchungsauftrag'],
                                    email: { sende_mail: true, kunde_id: this.untersuchungsauftrag?.kunde_id },
                                },
                            ),
                        );
                    }
                },
                error: error => {
                    this.notification.errorMessage('Der Untersuchungsauftrag konnte nicht gespeichert werden!', error);
                },
            });
    }

    createCurrentPosition() {
        const uap = new UntersuchungsauftragPosition();

        uap.artikel_id = this.selectedArtikel.artikel_id;
        uap.artikel = this.selectedArtikel.artikel_me;
        uap.anzahl = this.anzahlCtrl.value;
        uap.notiz = this.notizCtrl.value;

        return uap;
    }

    removePosition(p: UntersuchungsauftragPosition) {
        const index = this.positionen.indexOf(p);
        this.positionen.splice(index, 1);
        this.save();
    }
}
